import { createContext } from 'react';
import { noop } from "../../utils/noop";
export var TabsContext = createContext({
  id: null,
  onChange: noop,
  value: null,
  onMountTabs: noop,
  mountedTabs: new Set([])
});